export default __webpack_public_path__ + "static/media/PAFI_Pengumuman RUPS GMS Announcement 2026.20d20d5d.pdf";